import { z } from 'zod'
import { afterValid } from '~/services/api/contracts/afterValid'
import { ORDER_LINE_SPECIAL_INSTRUCTIONS_MAX } from '~/services/api/contracts/bounds/ORDER_LINE_SPECIAL_INSTRUCTIONS_MAX'
import { StoreCartRequestSchema, OrderTypeSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// A key absent from the raw input stays absent -- introducing it (even as null/undefined)
// would add a wire key callers never sent, breaking exact-body assertions downstream.
const normalize = fieldNormalizer({
  numericString: ['quantity'],
  blankToNull: ['special_instructions', 'requested_date', 'requested_time'],
  enums: [{ field: 'order_type', options: OrderTypeSchema.options }]
})

const requestSchema = StoreCartRequestSchema.extend({
  special_instructions: z.string().max(ORDER_LINE_SPECIAL_INSTRUCTIONS_MAX).nullish()
})

// A date with no time (or a time with no date) is half a reservation request.
const withRequestedPairing = afterValid(requestSchema, (request, context) => {
  if (request.requested_date != null && request.requested_time == null) {
    context.addIssue({
      code: 'custom',
      message: 'requested_time_required_with_requested_date',
      path: ['requested_time']
    })
  }
  if (request.requested_time != null && request.requested_date == null) {
    context.addIssue({
      code: 'custom',
      message: 'requested_date_required_with_requested_time',
      path: ['requested_date']
    })
  }
})

export const CartStore = (_context: NoContext) => z.preprocess(normalize, withRequestedPairing)
